import React from 'react';
import { Card } from '../ui/Card';
import { RatesTable } from './RatesTable';
import { ScopeType } from '../../api/billingRates';

interface RatesTabProps {
  scopeType: ScopeType;
  scopeId: number | string;
  entityName: string;
  propertyId?: number | string;
  customerId?: number | string;
  dealerId?: number | string;
}

export const RatesTab: React.FC<RatesTabProps> = ({ scopeType, scopeId, entityName, propertyId, customerId, dealerId }) => (
  <Card padding={false}>
    <div className="p-4 border-b border-gray-100">
      <h3 className="font-semibold text-gray-900">Billing Rates</h3>
      <p className="text-sm text-gray-500 mt-0.5">
        Custom rates for {entityName}. Overrides inherit from the level above. Click "Edit" to set a custom rate, or "Reset" to revert to the inherited rate.
      </p>
    </div>
    <RatesTable scopeType={scopeType} scopeId={scopeId} propertyId={propertyId} customerId={customerId} dealerId={dealerId} showStrategy />
  </Card>
);
